var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBigcommerceNegativeLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bigcommerceNegativeLogo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.145 13.663h3.028c.86 0 1.405-.473 1.405-1.235 0-.717-.544-1.235-1.405-1.235h-3.028c-.1 0-.186.086-.186.173v2.125c.014.1.085.172.186.172m0 4.896h3.128c.961 0 1.535-.489 1.535-1.35 0-.747-.545-1.35-1.535-1.35h-3.128c-.1 0-.186.086-.186.173v2.34c.014.115.085.187.186.187"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E7E7E7",
  d: "m24.221.053-8.953 8.93h1.464c2.281 0 3.63 1.436 3.63 3 0 1.236-.832 2.14-1.722 2.542-.144.058-.144.258.014.315 1.033.403 1.765 1.48 1.765 2.742 0 1.78-1.191 3.201-3.501 3.201h-6.341c-.1 0-.187-.085-.187-.172v-6.763L.563 23.642c-.13.13-.044.359.143.359h23.631a.16.16 0 0 0 .158-.158V.182c.043-.158-.158-.244-.273-.129"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bigcommerceNegativeLogo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h24v24H.5z"
})))));
export default SvgBigcommerceNegativeLogo;